// extracted by mini-css-extract-plugin
export default {"nav-item":"nav-item_nav-item__cMMtz","icon":"nav-item_icon__dLrqO"};